import KHero from './k-hero'
import heros from './heros'

export {
  KHero,
  heros
}
export default KHero
